// Généré automatiquement par scripts/ota/generate-ota-build-info.mjs au build — NE PAS ÉDITER À LA MAIN.
// Timestamp (epoch ms) du build de ce bundle web. Sert à l'anti-downgrade OTA.
export const OTA_BUILD_EPOCH = 1788126818891;
